import React from "react";
import { makeStyles } from "@mui/styles";
import Skeleton from '@mui/material/Skeleton';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "2%",
    marginRight: "2%",
    width: "95%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
  },
}));

export default function ListSkeleton({ numRows }) {
  const classes = useStyles();

  var rows = [];
  for (var i = 0; i < numRows; i++) {
    rows.push(
      <Skeleton animation="wave" height={numRows * 100} key={i} height={50} />
    );
  }

  return <div className={classes.root}>{rows}</div>;
}
